import type { ReasonDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReasonService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonDto[]>({
      method: 'GET',
      url: '/api/app/reason',
    },
    { apiName: this.apiName,...config });
}